// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__229uH","tg_link":"_styles_tg_link__+xXDJ"};